"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Footer = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styles2 = require("./styles");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Footer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Footer, _Component);

  var _super = _createSuper(Footer);

  function Footer() {
    var _this;

    (0, _classCallCheck2.default)(this, Footer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          classes = _this$props.classes,
          className = _this$props.className,
          children = _this$props.children;
      return children ? /*#__PURE__*/_react.default.createElement("footer", {
        id: id,
        className: (0, _classnames.default)("prmbl-footer", className, classes.wrapper)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("prmbl-footer", className, classes.inner)
      }, children)) : null;
    });
    return _this;
  }

  return Footer;
}(_react.Component);

exports.Footer = Footer;
(0, _defineProperty2.default)(Footer, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * The footer content
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   *
   * Utilized By:
   * LiveEdit,
   * Expansion Panel: Added so that ExpansionPanel could apply classes to the actions.
   *
   * Preamble => Page
   */
  className: _propTypes.default.string
});
(0, _defineProperty2.default)(Footer, "defaultProps", {
  className: ""
});

var _default = (0, _styles.withStyles)(_styles2.styles)(Footer);

exports.default = _default;